import * as PIXI from "pixi.js";
import Game from "../../../../../../src/Game";
import Layers from "../../../../../../src/layers/Layers";
import { Coord } from "../../../../../../src/types/Interface";


export default class Panel extends PIXI.Container {
  static instance: Panel;
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private dim = this.Game.getDim();
  private bg = this.addChild(new PIXI.Graphics());

  constructor() {
    super();
    if (!Panel.instance) { Panel.instance = this }
    this.addToLayer();
    this.addPanelBg();
    this.position.copyFrom(this.getCoord());
  }

  static getInstance = (): Panel => Panel.instance;
  
  private addToLayer = () => this.Layers.UITop.addChild(this);
  private addPanelBg() {
    const size = this.getBgSize();

    this.bg
      .roundRect( -size.width / 2, 0, size.width, size.height, 10)
      .fill(0xFFFFCC)
      .stroke({ color: 0x000000, width: 3 })
      .eventMode = "none"
  }
  getBgSize(): PIXI.Size {
    const isVertical = this.dim.WIDTH < this.dim.HEIGHT;
    return {
      width: isVertical ? 720 : 600,
      height: isVertical ? 840 : 840
    }
  }
  getCoord(): Coord {
     if(this.dim.WIDTH < this.dim.HEIGHT) {
      return {
        x: this.dim.WIDTH / 2,
        y: this.dim.HEIGHT / 2
      }
    }
    return {
      x: this.dim.WIDTH / 2 + 400,
      y: 30
    }
  }
}